import { ENV_APP_SOCIAL_URL } from "#/env"

export const DMCA_LINK = `${ENV_APP_SOCIAL_URL ?? 'https://bsky.social'}/about/support/copyright`
export const SUPPORT_PAGE = `${ENV_APP_SOCIAL_URL ?? 'https://bsky.social'}/about/support`
